





































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

import { Marker } from 'mapbox-gl';
import { GeocodeFeature } from '@mapbox/mapbox-sdk/services/geocoding';
import { PolygonGeoJsonOptions } from '@targomo/core/typings/api/payload';
import { TravelType } from '@targomo/core';
import TargomoService from '@/services/targomo.service';
import { FilterStore } from '@/store/filter';
import { MapStore } from '@/store/map';
import Autocomplete from '@/components/Autocomplete.vue';
import SelectTravelType from '@/components/SelectTravelType.vue';
import Slider from '@/components/forms/Slider.vue';
import { AddBicycleRoutes, RemoveBicycleRoutes } from '@/services/bicycle-routes.service';
import { AddBusRoutes, AddTrainRoutes, AddTrainRoutesFuture, RemoveRoutes } from '@/services/train-routes.service';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import { point } from '@turf/helpers';
import * as turf from '@turf/turf';

@Component({
  components: { Autocomplete, SelectTravelType, Slider }
})
export default class WidgetFilter extends Vue {
  @Prop({ required: true }) travelTypeOptions: any;
  @Prop({ required: true }) readonly setBottomSheet!: () => void;
  travelType: 'car' | 'transit' | 'airplane' = 'car';
  travelEdgeWeightsMin = 300;
  travelEdgeWeightsMax = 5400;
  travelEdgeWeights = 1800;
  disabled = true;
  city = '';
  toggle = false;
  travelTypes: Record<string, string | boolean>[] = [
    {
      name: 'Bus',
      opened: false,
      id: 'BusRoute'
    },
    {
      name: 'Train',
      opened: false,
      id: 'TrainRoute'
    }
  ];

  private _filterStore!: FilterStore;
  private _mapStore!: MapStore;

  bicycleRoutes = false;
  trainRoutes = false;
  busRoutes = false;

  @Emit()
  change() {
    return !this.disabled;
  }

  created() {
    this._filterStore = getModule(FilterStore, this.$store);
    this._mapStore = getModule(MapStore, this.$store);
    this._mapStore.setTravelType(this.travelType);
    this._mapStore.setTime(this.travelEdgeWeights);
    this.$root.$on('setPolygon', this.setPolygon);
  }

  newLocation(loc: GeocodeFeature) {
    this.city = loc.text;
    this.$root.$emit('city', loc.text);
    const [lng, lat] = loc.center;
    this._mapStore.setNewLastMarker([lng, lat]);
    this._filterStore.add([lng, lat]);

    this.setPolygon();
    this.disabled = false;
    this.change();
  }

  selectTravelType(param: Record<string, string | boolean>) {
    param.opened = !param.opened;
    if (param.id === 'TrainRoute') {
      if (param.opened) {
        AddTrainRoutes();
      } else {
        RemoveRoutes('TrainRouteCurrent');
        RemoveRoutes('TrainRouteLabelCurrent');
      }
    } else if (param.id === 'BusRoute') {
      if (param.opened) {
        AddBusRoutes();
      } else {
        RemoveRoutes('BusRoute');
        RemoveRoutes('BusRoute');
      }
    }
  }

  clear() {
    const { lngLat } = this._filterStore;

    if (!lngLat) return;

    this._mapStore.removeMarker({ type: 'Filter' });
    this._mapStore.removeLayer({ type: 'Filter' });
    this._mapStore.removeLayer({ type: 'FilterLine' });
    this._mapStore.resetPosition();

    this._filterStore.remove();
    this.disabled = true;
    this.change();
    this.city = '';
    this.$root.$emit('city', '');
    this.resetFilters();
  }

  travelChange(travelType: any) {
    if (this.travelType === 'transit') {
      this.travelTypes.forEach(travelType => {
        travelType.opened = false;
      });
      RemoveRoutes('TrainRouteCurrent');
      RemoveRoutes('TrainRouteLabelCurrent');
      RemoveRoutes('BusRoute');
      RemoveRoutes('BusRoute');
    }
    this.travelType = travelType;
    this._mapStore.setTravelType(travelType);
    this.setPolygon();
    if (travelType === 'bike' && this.bicycleRoutes) this.getBicycleRoutes();
  }

  resetFilters() {
    RemoveBicycleRoutes();
    RemoveRoutes('TrainRoute');
    RemoveRoutes('TrainRouteCurrent');
    RemoveRoutes('TrainRouteLabelCurrent');
    RemoveRoutes('TrainRouteLabel');
    RemoveRoutes('BusRoute');
  }

  timeChange(time: number) {
    this.travelEdgeWeights = time;
    this._mapStore.setTime(time);
    this.setPolygon();
  }

  setPolygon() {
    const currentDate = new Date()
      .toISOString()
      .split('T')[0]
      .replace(/-/g, '');
    let lngLat = this._filterStore.lngLat;
    if (this._mapStore.lastMarkerCoord.length) {
      lngLat = this._mapStore.lastMarkerCoord;
    }

    if (!lngLat) return;

    const options: PolygonGeoJsonOptions = {
      useClientCache: false,
      travelType: this.travelType as any,
      travelEdgeWeights: [this.travelEdgeWeights],
      maxEdgeWeight: this.travelEdgeWeightsMax,
      edgeWeight: 'time',
      srid: 4326,
      simplify: 200,
      serializer: 'geojson',
      buffer: 0.002,
      rushHour: true
    };

    // remove old marker
    this._mapStore.removeMarker({ type: 'Filter' });

    const markerElement = document.createElement('div');
    markerElement.className = 'marker-address';
    const dragIcon = `${process.env.VUE_APP_PROJECT}DragLocation.svg`;
    markerElement.innerHTML = `<div class="marker-address__point"><div class="marker-address__point__icon" style="background-image: url('${dragIcon}')"></div></div>`;

    // add new marker
    const marker = new Marker(markerElement, { draggable: true }).setLngLat(lngLat);
    marker.on('dragend', (e: any) => {
      const { lng, lat } = e.target._lngLat;
      const cord = point([lng, lat]);
      const poligonCord = this._mapStore.layers.find((el: any) => el.type === 'Locale').layer.source as Record<
        string,
        any
      >;
      const poligonCoordinates: Record<string, any> = {
        valleeSud: poligonCord.data.features.length
          ? poligonCord.data.features.reduce((array: any, iso: any) => turf.union(array, iso)) // union isochrones
          : null,
        laMeuse: poligonCord.data.features[0]
      };
      if (!booleanPointInPolygon(cord, poligonCoordinates[process.env.VUE_APP_PROJECT])) {
        if (this._mapStore.lastMarkerCoord.length) {
          marker.setLngLat(this._mapStore.lastMarkerCoord);
        } else {
          marker.setLngLat(lngLat);
        }
      } else {
        this._mapStore.setNewLastMarker([lng, lat]);
        const sources = [
          {
            lng,
            lat,
            id: 1,
            tm: {
              [this.travelType]: {
                frame: {
                  time: 27000,
                  date: currentDate
                }
              }
            }
          }
        ];
        TargomoService.GetPolygons(sources, options).then(geoJsonPolygon => {
          return this._mapStore.addFilter({
            geoJsonPolygon,
            type: 'Filter',
            city: this.city,
            dragMarker: true
          });
        });
      }
    });
    this._mapStore.addMarker({ marker, type: 'Filter' });

    const [lng, lat] = lngLat;

    const sources = [
      {
        lng,
        lat,
        id: 1,
        tm: {
          [this.travelType]: {
            frame: {
              time: 27000,
              date: currentDate
            }
          }
        }
      }
    ];

    TargomoService.GetPolygons(sources, options).then(geoJsonPolygon => {
      return this._mapStore.addFilter({ geoJsonPolygon, type: 'Filter', city: this.city });
    });
  }

  bicycleRoutesTrigger(value: boolean) {
    if (value) {
      this.getBicycleRoutes();
    } else {
      RemoveBicycleRoutes();
    }
  }

  trainRoutesTrigger(value: boolean, type: string) {
    if (type === 'BusRoute' && value === true) {
      this.trainRoutes = false;
      RemoveRoutes('TrainRoute');
      RemoveRoutes('TrainRouteLabelCurrent');
      RemoveRoutes('TrainRouteCurrent');
      this.changeYear({ year: 2020, id: 0, years: [] });
    }
    if (type === 'TrainRoute' && value === true) {
      this.busRoutes = false;
      RemoveRoutes('BusRoute');
      this.changeYear({ year: 2020, id: 0, years: [] });
    }
    if (!value) {
      RemoveRoutes(type);
      RemoveRoutes('TrainRouteLabelCurrent');
      RemoveRoutes('TrainRouteCurrent');
    }
  }

  getBicycleRoutes() {
    AddBicycleRoutes();
  }

  changeYear({ year, id, years }: any) {
    if (year === 2020) {
      if (this.busRoutes) {
        RemoveRoutes('BusRoute');
        AddBusRoutes();
      } else if (this.trainRoutes) {
        RemoveRoutes('TrainRoute');
        RemoveRoutes('TrainRouteCurrent');
        RemoveRoutes('TrainRouteLabel');
        RemoveRoutes('TrainRouteLabelCurrent');
        AddTrainRoutes();
      }
    } else if (this.trainRoutes) {
      RemoveRoutes('TrainRoute');
      RemoveRoutes('TrainRouteLabel');
      AddTrainRoutesFuture(year.toString(), id, years);
    }
  }
}
